const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

const toError = async (response) => {
	const payload = await response.json().catch(() => ({}));
	return payload?.error || `API Error: ${response.status} ${response.statusText}`;
};

export const generateSummary = async (messages, options = {}) => {
	const response = await fetch(`${BACKEND_BASE_URL}/api/ai/summary`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ messages, options }),
	});

	if (!response.ok) {
		throw new Error(await toError(response));
	}

	const data = await response.json();
	return data?.text || '';
};

export const generateSummaryStream = async (messages, options = {}, onChunk) => {
	const response = await fetch(`${BACKEND_BASE_URL}/api/ai/summary/stream`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ messages, options }),
	});

	if (!response.ok || !response.body) {
		throw new Error(await toError(response));
	}

	const reader = response.body.getReader();
	const decoder = new TextDecoder();
	let buffer = '';
	let fullText = '';

	while (true) {
		const { done, value } = await reader.read();
		if (done) break;

		buffer += decoder.decode(value, { stream: true });
		const events = buffer.split('\n\n');
		buffer = events.pop() || '';

		for (const event of events) {
			const line = event
				.split('\n')
				.map((x) => x.trim())
				.find((x) => x.startsWith('data: '));
			if (!line) continue;

			const payload = JSON.parse(line.slice(6));
			if (payload.error) {
				throw new Error(payload.error);
			}
			if (payload.done) {
				fullText = payload.fullText || fullText;
				continue;
			}
			if (payload.delta) {
				fullText = payload.accumulated || `${fullText}${payload.delta}`;
				onChunk?.(payload.delta, fullText);
			}
		}
	}

	return fullText;
};

export default generateSummary;
